module.exports = __webpack_public_path__ + "media/images/march8/march8-template-uz-e65c18f952450dc53c827b1ea6ab2578.png";